<div *ngIf="dependent" class="dependent-info">
	<div class="col-2">
		<a routerLink="{{ getDependentUrl() }}" class="dependent-link">
			<p>{{ dependent.user.name }} ({{ getDependentType() }})</p>
		</a>
	</div>
	<div class="col-1">
		<p class="information-label">Carteirinha de saúde</p>
		<div *ngIf="healthBenefitData?.not_aplicable">
			Não há carteirinha de saúde
		</div>
		<div
			*ngIf="
				!healthBenefitData?.not_aplicable && healthBenefitData?.wallet_number
			"
		>
			{{ healthBenefitData?.wallet_number }}
		</div>
		<div
			class="d-f ai-c"
			*ngIf="
				!healthBenefitData?.not_aplicable && !healthBenefitData?.wallet_number
			"
		>
			<mat-icon class="mr-nano" svgIcon="sanus-alert-red"></mat-icon>
			<p class="margin-top-3">Pendente</p>
		</div>
	</div>
	<div class="col-1">
		<p class="information-label">Carteirinha dental</p>
		<div *ngIf="dentalBenefitData?.not_aplicable">
			Não há carteirinha dental
		</div>
		<div
			*ngIf="
				!dentalBenefitData?.not_aplicable && dentalBenefitData?.wallet_number
			"
		>
			{{ dentalBenefitData?.wallet_number }}
		</div>
		<div
			class="d-f ai-c"
			*ngIf="
				!dentalBenefitData?.not_aplicable && !dentalBenefitData?.wallet_number
			"
		>
			<mat-icon class="mr-nano" svgIcon="sanus-alert-red"></mat-icon>
			<p class="margin-top-3">Pendente</p>
		</div>
	</div>
	<div class="mr-nano squared mtd" [matMenuTriggerFor]="menu">
		<mat-icon svgIcon="sanus-more-blue"></mat-icon>
	</div>
	<mat-menu #menu="matMenu">
		<button
			mat-menu-item
			[disabled]="isDisabledButton"
			(click)="onEditDependent()"
		>
			Cadastro
		</button>
		<button
			mat-menu-item
			[disabled]="isDisabledButton"
			(click)="onEditBenefits()"
		>
			Benefícios
		</button>
		<button
			mat-menu-item
			[disabled]="isDisabledButton"
			(click)="onDeleteDependent()"
		>
			Excluir
		</button>
	</mat-menu>
</div>
